<style>
footer .ft_info {
  margin-top: 30px;
}

footer .ft_cer {
  margin-top: 35px;
}
</style>

<template>
  <footer>
    <div class="wrap" style="padding-left: 20px !important;">
      <div class="ft_logo">
        <img alt="kt cloud 로고" src="@/assets/img/img_footer_logo.png">
      </div>
      <div>
        <ul class="ft_link">
          <!-- 2022.10.21 FJB System 수정 -->
          <li><a href="javascript:;" @click="preview('1')">
            <template v-if="state.type == 'public'">공공</template>
            kt cloud 마켓플레이스 이용약관</a></li>
          <li><a class="fc_red" href="javascript:;" @click="preview('3')">
            <template v-if="state.type == 'public'">공공</template>
            마켓플레이스 제휴사 개인정보처리방침</a></li>
        </ul>
        <div class="ft_info">
          <ul>
            <li>(주)케이티클라우드 대표이사 김봉균</li>
            <li>서울특별시 강남구 학동로 343 더피나클타워</li>
            <li>사업자 등록번호 : 696-87-02611</li>
          </ul>
          <ul>
            <li>고객센터 : 080-2580-005 <br>(기술 및 일반 상담 09:00 ~ 18:00 장애 문의  24시간)</li>
            <li v-if="state.footerYn == 'N'">호스팅제공자 ㈜케이티클라우드</li>
            <li v-else>수납센터 : 1551-1200 / pmt@ktcloud.com (미.수납 상담 09:00 ~ 18:00) 호스팅제공사 ㈜케이티클라우드</li>
          </ul>
          <p v-if="state.type == 'public'">Copyright© kt cloud Corp. All rights reserved.</p>
          <p v-else>Copyright© kt cloud Corp. All rights reserved.</p>
          <p style="color: gray;">kt cloud 마켓플레이스 내 판매되는 서비스는 개별 판매자가 판매하는 서비스입니다.
            <br>해당 상품의 경우 kt cloud는 통신판매중개자이며 통신판매의 당사자가 아닙니다.
            <br>개별 판매자가 판매하는 서비스와 관련하여 문제가 발생되는 경우 kt cloud는 이에 대한 책임을 부담하지 않습니다.</p>
        </div>

        <ul class="ft_cer">
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#csap" target="_blank">
              <img alt="" src="@/assets/img/img_footer_csap.png">
              <div>
                <p>공공기관 Cloud 보안인증 <br><span>CSAP</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#ismsp" target="_blank">
              <img alt="" src="@/assets/img/img_footer_isms.png">
              <div>
                <p>정보보호 및 개인정보보호 <br>관리체계 인증 <span>ISMS-P</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#csaStarGold" target="_blank">
              <img alt="" src="@/assets/img/img_footer_csa_star.png">
              <div>
                <p>글로벌 클라우드 정보통제 <br><span>CSA STAR Gold</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#iso27001" target="_blank">
              <img alt="" src="@/assets/img/img_footer_iso_27001.png">
              <div>
                <p>정보보호 경영 시스템 <br><span>ISO 27001</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#iso27701" target="_blank">
              <img alt="" src="@/assets/img/img_footer_iso_27701.png">
              <div>
                <p>프라이버시 보호 경영시스템 <br><span>ISO 27701</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#iso27017" target="_blank">
              <img alt="" src="@/assets/img/img_footer_iso_27017.png">
              <div>
                <p>Cloud 정보보호 관리체계 <br><span>ISO 27017</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#iso27018" target="_blank">
              <img alt="" src="@/assets/img/img_footer_iso_27018.png">
              <div>
                <p>Cloud 내 개인식별정보 <br>관리체계 <span>ISO 27018</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#iso22301" target="_blank">
              <img alt="" src="@/assets/img/img_footer_iso_22301.png">
              <div>
                <p>비즈니스 연속성 경영시스템 <br><span>ISO 22301</span></p>
              </div>
            </a>
          </li>
          <li>
            <a href="https://gcloud.kt.com/business/securityCertification#iso27799" target="_blank">
              <img alt="" src="@/assets/img/img_footer_iso_27799.png">
              <div>
                <p>의료 개인정보보호 <br><span>ISO 27799</span></p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>

</template>
<script>
import {onBeforeMount, reactive} from "vue";
import {useRouter} from "vue-router";
import commonMgt from "@/assets/js/marketPartnerCommon.js";

export default {
  name      : 'Footer',
  components: {},
  setup     : () => {
    const router = useRouter();
    const {common} = commonMgt();

    const state = reactive({
      type    : "",
      footerYn: ""
    });

    const preview = (str) => {
      var type = process.env.VUE_APP_POTAL_MARKET_TYPE
      if (type == 'enterprise') {
        str = Number(str) + 3;
      }
      let routeUrl = router.resolve({
        path : "/signUp/signTerms",
        query: {termsNum: str}
      });
      window.open(routeUrl.href, '_blank');
    }

    onBeforeMount(() => {
      state.type = process.env.VUE_APP_POTAL_MARKET_TYPE;
      var codeList = common.getCode("FOOTER_YN");
      codeList.then((value) => {
        if (value != null && value.length != 0) {
          state.footerYn = value[0].code
        }
      });
    });
    return {
      state,
      preview
    }
  }
}
</script>
